import { render, staticRenderFns } from "./RechargeDialog.vue?vue&type=template&id=2ddea616&scoped=true"
import script from "./RechargeDialog.vue?vue&type=script&lang=js"
export * from "./RechargeDialog.vue?vue&type=script&lang=js"
import style0 from "./RechargeDialog.vue?vue&type=style&index=0&id=2ddea616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddea616",
  null
  
)

export default component.exports